import { SPONSOR } from '@/constants/sponsor';
import { APP } from '@/constants/brand';
import { Phone } from 'lucide-react';
import { trackSponsorClick } from '@/lib/tracking';

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 mt-16 bg-zinc-950">
      <div className="max-w-6xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <div className="font-display text-2xl text-zinc-100 tracking-wide">{APP.name}</div>
          <p className="text-zinc-500 text-sm mt-2 max-w-xs">
            AI-powered step-by-step repair guides for every trade. You can fix it.
          </p>
        </div>
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.2em] text-amber-500 mb-3">
            Featured Local Pro
          </div>
          <div className="text-zinc-100 font-semibold">{SPONSOR.name}</div>
          <div className="text-zinc-500 text-sm">{SPONSOR.city}</div>
          <a
            href={SPONSOR.phoneHref}
            onClick={() => trackSponsorClick('footer')}
            className="inline-flex items-center gap-2 mt-2 text-amber-500 hover:text-amber-400 font-mono text-sm"
          >
            <Phone size={14} /> {SPONSOR.phone}
          </a>
        </div>
        <div className="md:text-right">
          <div className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3">
            Note
          </div>
          <p className="text-zinc-500 text-xs max-w-xs md:ml-auto">
            Guidance is informational. Always follow local codes and safety practices.
            For advanced electrical work, we recommend {SPONSOR.name}.
          </p>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-4 text-center text-zinc-600 text-xs font-mono uppercase tracking-widest">
        © {new Date().getFullYear()} {APP.name}
      </div>
    </footer>
  );
}
